import { Component } from '@theme/component';

const desktop = window.matchMedia('(min-width: 990px)');

class MarylunaFooterComponent extends Component {
  #wrapper = document.querySelector('.page-wrapper');

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('scroll', this.#updateTop, { passive: true });
    this.#wrapper?.addEventListener('scroll', this.#updateTop, { passive: true });
    desktop.addEventListener('change', this.#syncColumns);
    this.#syncColumns();
    this.#updateTop();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('scroll', this.#updateTop);
    this.#wrapper?.removeEventListener('scroll', this.#updateTop);
    desktop.removeEventListener('change', this.#syncColumns);
  }

  toggleColumn(event) {
    if (desktop.matches) event.preventDefault();
  }

  scrollToTop() {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.scrollTo({ top: 0, behavior });
    this.#wrapper?.scrollTo({ top: 0, behavior });
  }

  #syncColumns = () => {
    for (const column of this.querySelectorAll('.ml-footer__column')) column.open = desktop.matches;
  };

  #updateTop = () => {
    const offset = Math.max(window.scrollY, this.#wrapper?.scrollTop ?? 0);
    this.refs.top?.classList.toggle('is-visible', offset > 400);
  };
}

if (!customElements.get('maryluna-footer-component')) {
  customElements.define('maryluna-footer-component', MarylunaFooterComponent);
}
